import { styled } from '@mui/system'
import { Paper, Typography } from '@mui/material'

export const PrivacyPolicyContainer = styled('main')(() => ({
  display: 'flex',
  justifyContent: 'center',
  minHeight: 'calc(100vh - 5rem - 5rem)',
  padding: '1.6rem',
  background: 'rgba(0,0,0,0.05)',
}))

export const PrivacyPolicyCard = styled(Paper)(({ theme }) => ({
  width: '100%',
  maxWidth: '52rem',
  padding: '2rem',
  display: 'flex',
  flexDirection: 'column',
  gap: '0.75rem',
  [theme.breakpoints.down('sm')]: {
    padding: '1.2rem',
  },
}))

export const PrivacyPolicyTitle = styled(Typography)(() => ({
  marginBottom: '0.5rem',
  fontWeight: 600,
}))

export const PrivacyPolicySectionTitle = styled(Typography)(({ theme }) => ({
  marginTop: '0.75rem',
  color: theme.palette.primary.main,
  fontWeight: 600,
}))

export const PrivacyPolicyText = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.secondary,
  lineHeight: 1.6,
}))

export const PrivacyPolicyNote = styled(Typography)(({ theme }) => ({
  color: theme.palette.error.main,
  lineHeight: 1.5,
  fontStyle: 'italic',
  fontSize: '0.85rem',
  borderLeft: `3px solid ${theme.palette.error.main}`,
  paddingLeft: '0.75rem',
  marginTop: '-0.25rem',
}))
